import { render, staticRenderFns } from "./dashboard-red.vue?vue&type=template&id=55d244aa&scoped=true"
import script from "./dashboard-red.vue?vue&type=script&lang=js"
export * from "./dashboard-red.vue?vue&type=script&lang=js"
import style0 from "./dashboard-red.vue?vue&type=style&index=0&id=55d244aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d244aa",
  null
  
)

export default component.exports